<template>
    <div class="pp-list">
        <div class="pp-list__header">
            <slot></slot>
        </div>
        <div class="pp-list__body">
            <template v-if="data.length">
                <pCellGroup 
                    v-for="(item, index) in data" :key="index" >
                    <component 
                        v-for="(header, indexHeader) in header" :key="indexHeader"
                        :is="componentName[header.type]"
                        :with-more="header.withMore"
                        @click.native="clickCell(item, index, header)">
                        <pListLabel :render="header.renderLabel()"
                        ></pListLabel>
                        <pListValue slot="suffix" 
                            :render="header.renderValue(item, index)"
                        ></pListValue>
                    </component>
                </pCellGroup>
            </template>
            <pDivider v-else :text="emptyText"></pDivider>
        </div>
    </div>
</template>

<script>
import pCellGroup from '../../cell-group'
import pCell from '../../cell'
import pCellSlide from '../../cell-slide'
import pCellExpand from '../../cell-expand'
import pListLabel from './list-label'
import pListValue from './list-value'
import pDivider from '../../divider'

/**
 * 列表
 * @param {Array} data 列表数据
 * @param {String} emptyText 空数据展示文字
 * 
 * @event click-cell 点击单元格 {row行数据, index所在行, column列数据}
 */
export default {
    name: 'pp-list',
    components: {
        pCellGroup, pCell, pCellSlide, pCellExpand,
        pListLabel, pListValue, 
        pDivider,
    },
    provide: function() {
        return {
            'List': this,
        };
    },
    props: {
        data: {
            type: Array,
            default: [],
        },
        emptyText: {
            type: String,
            default: '哎呀，没有数据',
        },
    },
    data: function() {
        return {
            header: [],
            list: [],
            componentName: {
                'slide': 'pCellSlide',
                'expand': 'pCellExpand',
                '': 'pCell',
            },
        };
    },
    methods: {
        clickCell: function(row, index, column) {
            this.$emit('click-cell', {
                row, index, column
            })
        },
    },
}
</script>
